import BrandTitle from '@modules/common/components/brand-title';
import Breadcrumbs from '@modules/common/components/breadcrumbs';
import Container from '@modules/common/components/container';

const breadcrumbsItems = [
  {
    name: '首頁',
    href: '/',
  },
  {
    name: '關於火星生技',
    href: '',
  },
];

export default function AboutPage() {
  return (
    <Container className="mb-[75px] mt-12 flex flex-col gap-12">
      <Breadcrumbs items={breadcrumbsItems} />
      {/* TODO: Brand Img */}
      <div className="min-h-[200px] w-full rounded-md bg-white-30 lg:min-h-[400px]"></div>
      <div className="self-center">
        <BrandTitle title="關於火星生技" />
      </div>
      <div className="flex max-w-[1000px] flex-col gap-8 self-center text-black-20">
        <p>
          火星生技（Marx Biotech Co.）成立於 2021 年，從初期創立 TAIZAKU
          男性保健品牌之後，就迅速在線上網路平台及藥妝藥局零售市場中發展 O2O 與
          OMO 全通路的布局，成功在市場與通路端建立信任度與營運成長。
        </p>
        <p>
          除了自主品牌經營，也持續與品牌業者合作，憑藉集團所累積的通路經營經驗、資源及全面營運支援等，輔導純電商品牌落地到實體通路，加速品牌的市場擴展，同時也為線下藥妝藥局注入不同市場領域的新客群。
        </p>
        <p>
          隨著品牌商整體營運持續成長，加上各品牌的屬性、客群類型、營銷模式與資源優勢皆不同，集團在
          2023
          年下半年進行「品牌加速器」發展計畫，透過與品牌商更深入的資源整合與聯合發展，將扶持更多在大健康領域中獨具潛力的國內外優質品牌業者，協助優化其商品與市場布局策略，並透過火星建構的通路銷售平台，加速品牌走向全球市場發展、帶來新的機遇與可能。
        </p>
      </div>
    </Container>
  );
}
